import { render } from "./QImage.vue?vue&type=template&id=3155c8be"
import script from "./QImage.vue?vue&type=script&lang=js"
export * from "./QImage.vue?vue&type=script&lang=js"

import "./QImage.vue?vue&type=style&index=0&id=3155c8be&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__